import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, ArrowUpRight, Loader2, Radio } from "lucide-react";
import { adminApi, setToken } from "@/lib/adminApi";

export default function AdminLoginPage() {
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [state, setState] = useState({ status: "idle", error: null });

  const onSubmit = async (e) => {
    e.preventDefault();
    setState({ status: "submitting", error: null });
    try {
      const { token } = await adminApi.login(password);
      setToken(token);
      nav("/admin/artwork");
    } catch (err) {
      setState({ status: "error", error: err.detail || err.message || "Erreur" });
    }
  };

  return (
    <div className="mw-app admin-login-page">
      <div className="admin-login-card">
        <div className="admin-login-brand">
          <span className="mw-brand-mark" aria-hidden="true">
            <Radio size={20} strokeWidth={2.2} />
          </span>
          <div>
            <div className="admin-login-eyebrow">Admin · Artwork Central</div>
            <div className="admin-login-title">MediaWebRadio</div>
          </div>
        </div>

        <form className="mw-form" onSubmit={onSubmit} data-testid="admin-login-form">
          <label className="mw-label">
            Mot de passe administrateur
            <div className="admin-login-input-wrap">
              <Lock size={14} className="admin-login-input-icon" />
              <input
                type="password"
                required
                placeholder="•••••••••"
                className="mw-input admin-login-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-login-input"
                disabled={state.status === "submitting"}
                autoFocus
              />
            </div>
          </label>

          {state.error && (
            <div className="mw-form-error" data-testid="admin-login-error">
              {state.error}
            </div>
          )}

          <button
            type="submit"
            className="mw-btn mw-btn-primary mw-form-submit"
            data-testid="admin-login-submit"
            disabled={state.status === "submitting"}
          >
            {state.status === "submitting" ? (
              <>
                <Loader2 size={16} className="mw-spin" /> Connexion…
              </>
            ) : (
              <>
                Se connecter <ArrowUpRight size={16} />
              </>
            )}
          </button>
        </form>

        <div className="admin-login-footer">
          Accès réservé. Toute tentative est enregistrée.
        </div>
      </div>
    </div>
  );
}
